import Vue from 'vue/dist/vue.js';

export default class BlogSingle{
	constructor(){
		console.log('BlogSingle :: init');		

		new Vue({
			el: '#blog-single',
			data(){
				return{
	                blogLength : 3,
	                blogs : []
	            }
			},
			mounted(){
				this.allCaptionDivs = this.$refs.article.querySelectorAll('.wp-caption');
				this.removeCaptionDiv();
				this.allContentImages = this.$refs.article.querySelectorAll('img');
				this.wrapImages();
				this.blogs = this.$refs.listing.querySelectorAll('.bloc-post');
				this.showBlogs();
			},
			methods: {
				removeCaptionDiv(){
					// Remove div.wp-caption that is created by WP and comes with a giant inline width
					for (let i=0; i<this.allCaptionDivs.length; i++) {
						while (this.allCaptionDivs[i].firstChild)
						{
						    this.allCaptionDivs[i].parentNode.insertBefore(this.allCaptionDivs[i].firstChild,this.allCaptionDivs[i]);
						}
						this.allCaptionDivs[i].parentNode.removeChild(this.allCaptionDivs[i]);
					}
				},
				wrapImages(){
					// Wrap Wysiwyg images in div to style them
					for (let i=0; i<this.allContentImages.length; i++) {
						let $wrapperDiv = document.createElement('div');
						$wrapperDiv.classList.add('img-wrapper');
						this.wrap(this.allContentImages[i], $wrapperDiv);
					}
					this.$refs.article.classList.remove('transparent');
				},
				wrap(el, wrapper) {
				    el.parentNode.insertBefore(wrapper, el);
				    wrapper.appendChild(el);
				},
				loadmore () {
					this.blogLength += 3;
					this.showBlogs();
				},
				showBlogs(){
					// Blog article listing at the bottom of the page
					for(let i=0; i<this.blogs.length; i++)
					{
						if(i > this.blogLength - 1){
							this.blogs[i].style.visibility = 'hidden';
							this.blogs[i].style.height = '0px';
						}else{
							this.blogs[i].style.visibility = '';
							this.blogs[i].style.height = '';
							this.blogs[i].style.opacity = '1';
						}
					};

					if(this.blogLength >= this.blogs.length){
						this.$refs.loadmore.style.display = 'none';
					}						
				}
			}
		})

	}
}